import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabView } from 'primeng/tabview';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/auth/authentication.service';
import { PermissionService } from 'src/app/auth/permission.service';
import { LanguageDataModelForTabs, userTabDetails } from 'src/app/_models/tabs.data.model';
import { BreadcrumbService } from 'src/app/_services/breadcrumb.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { ProfilesService } from 'src/app/_services/admin/profiles.service';
import { UsersService } from 'src/app/_services/admin/users.service';
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';

@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.scss'],
  standalone: false
})
export class ViewUserComponent extends SubscriptionUtil implements OnInit, OnDestroy, AfterViewInit {
  params: any;
  profile: any = {};
  profileData: any;

  translate: any;
  loadTabs: any[] = [];
  tabMenu!: any[];
  activeIndexAccess: any = 0;
  @ViewChild(TabView, { static: false }) tabView!: TabView;

  isAdmin: boolean = false;
  manageShifts: boolean = false;
  addonFeature: any;
  hideListView: boolean = false;

  private refreshUser!: Subscription;
  private refreshPhoto!: Subscription;
  displayNewJO2: boolean = false;
  displayNewWORKFLOW2: boolean = false;
  constructor(
    private userService: UsersService,
    public auth: AuthenticationService,
    private route: ActivatedRoute,
    private util: UtilServiceService,
    private spinner: NgxSpinnerService,
    private perm: PermissionService,
    private profileService: ProfilesService,
    private breadcrumbService: BreadcrumbService,
    private languageTranslateService: LanguageTranslateService,
  ) {
    super();

    this.breadcrumbService.setSetupItems([]);
    this.breadcrumbService.setItems([]);

    this.refreshUser = this.userService.refreshList$.subscribe(() => {
      if (!this.params?.id) {
        return;
      }
      const type = this.params.id !== this.auth.getUserId() ? '' : 'myProfile';
      this.loadUserProfile(this.params.id, type);
    });

    this.refreshPhoto = this.profileService.refreshProfilePhoto$.subscribe(
      (_res: any) => {
        const id = this.params?.id || this.auth.getUserId();
        if (!id) {
          return;
        }
        const type = String(id) !== String(this.auth.getUserId()) ? '' : 'myProfile';
        this.loadUserProfile(id, type);
      }
    );

  }

  ngOnInit(): void {
    const hideKeys = [
      'LISTVIEW_ASSETS',
      'LISTVIEW_CONTRACT',
      'LISTVIEW_CUSTOMER',
      'LISTVIEW_JO',
      'LISTVIEW_PM',
      'LISTVIEW_SPARE_PARTS',
      'LISTVIEW_PROJECTS',
      'LISTVIEW_SALES_ORDERS',
      'LISTVIEW_SITES',
      'LISTVIEW_TASKS',
      'LISTVIEW_TICKETS'
    ];
    const hiddenPackages: string[] = this.auth.addonPackageListToHide() ?? [];
    this.hideListView = hideKeys.every((key) => hiddenPackages.includes(key));

    this.addonFeature = this.auth.getAddonFeatureLists();
    this.loadTabs = userTabDetails;
    this.isAdmin = this.perm.capable('manage_users', 'read');
    this.manageShifts = this.perm.capable('manage_shifts', 'read');

    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.loadTabs.forEach((element) => {
            if (element.translatePath) {
              element.headerName = this.languageTranslateService.getNestedValue(
                this.translate,
                element.translatePath
              );
            }
          });
          this.init();
        }
      })
    );
  }

  init() {
    this.push(
      this.route.queryParams.subscribe((params: any) => {
        if (params.id) {
          this.params = params;
          this.loadUserProfile(this.params.id, '');
        } else {
          this.params = { id: this.auth.getUserId() };
          this.loadUserProfile(this.params.id, 'myProfile');
        }
 this.addonFeature = this.auth.getAddonFeatureLists();
         /***********End Check if the PMV3 package is old or new ***********/
    var tenantPackagesJO2 = this.auth.getPackageCodeWithList("JO2");
    if (localStorage.getItem("packageCode") == "Old") {
      this.displayNewJO2 = this.addonFeature.addonJO2 == "JO2" ? true : false;
    } else {
      if (this.auth.getAddonPackageListsToHide("JO2")) {
        this.displayNewJO2 =
          tenantPackagesJO2.addonPackageList == "JO2" ||
          this.addonFeature.addonJO2 == "JO2"
            ? true
            : false;
      } else {
       this.displayNewJO2 = false;
      }
    }


     /***********End Check if the WORKFLOW2 package is old or new ***********/
    var tenantPackagesWORKFLOW2 = this.auth.getPackageCodeWithList("WORKFLOW2");
    if (localStorage.getItem("packageCode") == "Old") {
      this.displayNewWORKFLOW2 = this.addonFeature.addonWORKFLOW2 == "WORKFLOW2" ? true : false;
    } else {
      if (this.auth.getAddonPackageListsToHide("WORKFLOW2")) {
        this.displayNewWORKFLOW2 = tenantPackagesWORKFLOW2.addonPackageList == "WORKFLOW2" || this.addonFeature.addonWORKFLOW2 == "WORKFLOW2"
            ? true
            : false;
      } else {
        this.displayNewWORKFLOW2 = false;
      }
    }



        const storedIndex = localStorage.getItem('activeIndexAccess');
        this.activeIndexAccess = storedIndex == undefined ? 0 : Number(storedIndex);

        setTimeout(() => {
          if (this.tabView) {
            this.loadData(this.activeIndexAccess, this.tabView);
          }
        }, 500);
      })
    );
  }

  loadBreadCrumb() {
    this.breadcrumbService.setSetupItems([
      {
        label: this.translate?.setup.users.users.label.plural,
        routerLink: ['/dashboard/setup/allUser'],
        meta: { navigation: { root: true } },
      },
      {
        label: (this.profile?.firstName || '') + ' ' + (this.profile?.lastName || ''),
        meta: { navigation: { include: true } },
      },
    ]);
  }

  loadUserProfile(id: any, _type: any) {
    this.spinner.show();
    this.push(
      this.userService.getUserProfile(id).subscribe((profile: any) => {
        this.profile = profile || {};

        const aiFeatures = {
          dailyJobRundown: this.profile.dailyJobRundown ? this.profile.dailyJobRundown : false,
          postJobSummary: this.profile.postJobSummary ? this.profile.postJobSummary : false,
          taskDurationSuggestion: this.profile.taskDurationSuggestion
            ? this.profile.taskDurationSuggestion
            : false,
          checklistGeneration: this.profile.checklistGeneration
            ? this.profile.checklistGeneration
            : false,
          jobOrderNoteSuggestions: this.profile.jobOrderNoteSuggestions
            ? this.profile.jobOrderNoteSuggestions
            : false,
          jobOrderSparePartSuggestions: this.profile.jobOrderSparePartSuggestions
            ? this.profile.jobOrderSparePartSuggestions
            : false,
        };
        localStorage.setItem('aiFeatures', btoa(JSON.stringify(aiFeatures)));
        this.userService.getAIChatEnable(aiFeatures);

        this.loadBreadCrumb();
        if (this.profile?.profileId) {
          this.loadProfile(this.profile.profileId);
        } else {
          this.profileData = null;
          this.spinner.hide();
        }
      })
    );
  }

  private loadProfile(id: any) {
    this.push(
      this.profileService.getProfileById(id).subscribe((profileData: any) => {
        this.profileData = profileData;
        this.spinner.hide();
      })
    );
  }

  ngAfterViewInit() {
    if (this.params?.id == this.auth.getUserId() || this.isAdmin) {
      this.highlightTab();
    }
  }

  highlightTab(): void {
    if (this.tabView) {
      this.loadData(this.activeIndexAccess, this.tabView);
    }
  }

  loadData(e: any, tabView: TabView) {
    this.handleChange(e, tabView);
  }

  goToShiftsTab(): void {
    // if (!this.manageShifts || !this.tabView?.tabs?.length) {
    //   return;
    // }

    const shiftsHeader = this.loadTabs[4]?.headerName;
    const shiftsIndex = this.tabView.tabs.findIndex((tab: any) => tab.header === shiftsHeader);
    if (shiftsIndex >= 0) {
      this.handleChange(shiftsIndex, this.tabView);
    }
  }

  handleChange(e: any, _tabView: TabView) {
    let changedTabIndex;
    if (e?.index >= 0) {
      changedTabIndex = e.index;
    } else {
      changedTabIndex = e;
    }

    if (!this.tabView?.tabs?.[changedTabIndex]) {
      return;
    }

    const currentTabHeader = this.tabView.tabs[changedTabIndex].header;
    localStorage.setItem('activeIndexAccess', String(changedTabIndex));
    this.activeIndexAccess = changedTabIndex;
    this.setTabHeader(currentTabHeader);
  }

  setTabHeader(headerValue: any) {
    this.getLanguageForMenu();
    this.loadTabs.forEach((element) => {
      element.highlight = false;
    });

    let filteredModule: any = null;
    try {
      filteredModule = this.util.setTabHeaderData(
        headerValue,
        this.tabMenu,
        this.loadTabs,
        null
      );
    } catch (_e) {
      filteredModule = null;
    }

    this.loadTabs.forEach((element) => {
      if (
        filteredModule?.plural == element.headerName ||
        filteredModule?.singular == element.headerName ||
        filteredModule?.details == element.headerName ||
        filteredModule?.history == element.headerName ||
        filteredModule?.selectedSubTab == element.headerName ||
        element.headerName == headerValue
      ) {
        element.highlight = true;
      }
    });
  }

  getLanguageForMenu() {
    const data: any = new LanguageDataModelForTabs(this.translate);
    this.tabMenu = [...data.moduleData];
    _.remove(this.tabMenu, (n: any) => n == undefined);
  }

  push(obs: any) {
    super.push(obs);
  }

  ngOnDestroy() {
    if (this.refreshUser) {
      this.refreshUser.unsubscribe();
    }
    if (this.refreshPhoto) {
      this.refreshPhoto.unsubscribe();
    }
    this.breadcrumbService.setSetupItems([]);
    super.ngOnDestroy();
  }
}
